import { render } from "./ResponsiveContent.vue?vue&type=template&id=5cdf8918"
import script from "./ResponsiveContent.vue?vue&type=script&lang=ts"
export * from "./ResponsiveContent.vue?vue&type=script&lang=ts"
script.render = render

export default script